/* eslint-disable no-underscore-dangle */

import PaymentSavedCardsView from '../../views/payments/PaymentSavedCardsView';
import BasePaymentController from 'app/src/controllers/payments/BasePaymentController';
import PaymentProvider from 'app/src/payments/PaymentProvider';
import SaleManager from 'app/src/payments/SaleManager';

type SavedCard = {
  brand: string;
  last4: string;
  isDefault: boolean;
  isExpired: boolean;
  isSelected: boolean;
  isAvailable: boolean;
};

export default class PaymentSavedCardsViewController extends BasePaymentController {
  constructor(saleManager: SaleManager, paymentProvider: PaymentProvider, savedCards: SavedCard[]) {
    super(saleManager);

    let balance = saleManager.pendingBalance;

    if (balance.isZero() && paymentProvider.activeGatewayAllowsNegativePaymentRefunds) {
      // if we allow refunds via negated payments then set the amount to negated amount of credit payments
      // currently in the sale
      balance = saleManager.totalCreditPayments.negated();
    }

    this.view = new PaymentSavedCardsView({
      viewData: {
        savedCards,
        balance,
        onSavedCardsFinished: this.onSavedCardsFinished.bind(this),
        pli: paymentProvider.activeGatewayPli ?? '',
      },
      saleManager: this._saleManager,
    });
  }

  onSavedCardsFinished() {
    this.trigger('saved:cards:finished');
  }
}
